export interface KydUnenrollRequest {
  enrollmentId: number;
  policyNumber: string;
}
